import {
	legacyPermissionsEnabled,
	PermissionName,
	currentUserHasAccess,
} from '@netx/core-permissions-next';
import {useCurrentUser} from '@netx/core-user-next/store/currentUser';

export const canManageUserIntegrations = () => {
	if (legacyPermissionsEnabled())
		return useCurrentUser.getState().user.canCreateAPITokens === true;
	return currentUserHasAccess(PermissionName.CREATE_API_TOKENS);
};
